document.addEventListener("DOMContentLoaded", function () {
  // Strip PriceSpider's inline display:block from the accordion WTB widget
// PS sets style="display: block" via JS which overrides our flex layout
function fixWtbAccordionDisplay() {
  const wtb = document.querySelector('.vf-wtb-accordion');
  if (!wtb) return;
  if (wtb.style.display) {
    wtb.style.removeProperty('display');
  }
}

// Run after PS initializes (it fires quickly but after DOMContentLoaded)
setTimeout(fixWtbAccordionDisplay, 500);

// Also watch for PS mutating the element
const wtbEl = document.querySelector('.vf-wtb-accordion');
if (wtbEl) {
  new MutationObserver(() => {
    if (wtbEl.style.display) wtbEl.style.removeProperty('display');
  }).observe(wtbEl, { attributes: true, attributeFilter: ['style'] });
}

  // ── Gallery — all Swiper init inside onReady so CSS is guaranteed available ──
  if (typeof SwiperLoader !== 'undefined') {
    SwiperLoader.onReady(initGallery);
  } else {
    // SwiperLoader not found — fall back to direct init
    initGallery();
  }

  function initGallery() {
    const thumbsDesktop = new Swiper(".mainGalleryThumbs", {
      spaceBetween: 16,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      direction: "vertical",
      slideToClickedSlide: true,
      navigation: {
        nextEl: ".mainGalleryThumbs-button-next",
        prevEl: ".mainGalleryThumbs-button-prev",
      },
    });

    const thumbsMobile = new Swiper(".mainGalleryThumbsMobile", {
      spaceBetween: 16,
      slidesPerView: 3,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });

    const main = new Swiper(".mainGallery", {
      spaceBetween: 16,
      slidesPerView: 1,
      navigation: {
        nextEl: ".mainGallery-button-next",
        prevEl: ".mainGallery-button-prev",
      },
      on: {
        init(sw) {
          sw.el.classList.add('swiper-initialized');
          const i = sw.activeIndex || 0;
          thumbsDesktop.slideTo(i, 0);
          thumbsMobile.slideTo(i, 0);
          updateThumbActive(i);
        },
      },
    });

    function enableThumbClick(swiper) {
      swiper.on("click", () => {
        const i = swiper.clickedIndex;
        if (typeof i === "number" && i >= 0) {
          main.slideTo(i);
          thumbsDesktop.slideTo(i);
          thumbsMobile.slideTo(i);
          updateThumbActive(i);
        }
      });
    }
    enableThumbClick(thumbsDesktop);
    enableThumbClick(thumbsMobile);

    main.on("slideChange", () => {
      const i = main.activeIndex;
      thumbsDesktop.slideTo(i);
      thumbsMobile.slideTo(i);
      updateThumbActive(i);
    });

    function updateThumbActive(activeIndex) {
      [thumbsDesktop, thumbsMobile].forEach((sw) => {
        sw.slides.forEach((sl) => sl.classList.remove("is-thumb-active"));
        const s = sw.slides[activeIndex];
        if (s) s.classList.add("is-thumb-active");
        sw.updateSlidesClasses();
      });
    }

    // Slide gallery to a specific media ID
    function slideToMediaId(mediaId) {
      if (!mediaId) return;
      const slides = Array.from(
        document.querySelectorAll(".mainGallery .swiper-wrapper > .swiper-slide")
      );
      const idx = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (idx < 0) return;
      main.slideTo(idx);
      thumbsDesktop.slideTo(idx);
      thumbsMobile.slideTo(idx);
      updateThumbActive(idx);
    }

    // ── Stay AI price sync ────────────────────────────────────────────────────
    function syncPriceFromStayAi(variantSelectorEl) {
      const stayHost = variantSelectorEl.querySelector(
        'purchase-options[data-stayai-subscription-widget]'
      );
      if (!stayHost) return;

      function isSubscriptionSelected() {
        const radio = stayHost.querySelector('input[id="purchaseTypeSubscription"]');
        return radio ? radio.checked : false;
      }

      function getSubscriptionPrice() {
        const el = stayHost.querySelector('[data-stayai-subscription-price]');
        if (!el) return null;
        return (
          Array.from(el.childNodes)
            .filter((n) => n.nodeType === Node.TEXT_NODE)
            .map((n) => n.textContent.trim())
            .filter(Boolean)
            .join('') || null
        );
      }

      function getOnetimePrice() {
        const el = stayHost.querySelector('[data-stayai-onetime-price]');
        return el ? el.textContent.trim() : null;
      }

      function pushPriceUpdate() {
        const isSub = isSubscriptionSelected();

        // Guard: if subscription radio is checked but the current variant has no
        // selling plans, Stay AI's subscription price display is stale from the
        // previous variant. Fall back to the variant's own base price.
        if (isSub) {
          const vs = document.querySelector('product-variant-selector');
          if (vs) {
            const variant = vs.variants.find((v) => v.id === vs.selectedVariantId);
            if (variant && (!variant.selling_plan_allocations || variant.selling_plan_allocations.length === 0)) {
              const basePrice = vs.formatMoney(variant.price);
              const variantPriceEl = document.querySelector('.lsg-buybox .variant-price');
              if (variantPriceEl && variantPriceEl.textContent.trim() !== basePrice) {
                variantPriceEl.textContent = basePrice;
              }
              document.dispatchEvent(new CustomEvent('vf:stayai-price-updated', {
                bubbles: true,
                detail: { price: basePrice, isSubscription: false },
              }));
              return;
            }
          }
        }

        const price = isSub ? getSubscriptionPrice() : getOnetimePrice();
        if (!price) return;

        const variantPriceEl = document.querySelector('.lsg-buybox .variant-price');
        if (variantPriceEl && variantPriceEl.textContent.trim() !== price) {
          variantPriceEl.textContent = price;
        }

        document.dispatchEvent(
          new CustomEvent('vf:stayai-price-updated', {
            bubbles: true,
            detail: { price, isSubscription: isSub },
          })
        );
      }

      stayHost.addEventListener('change', (e) => {
        if (
          e.target.matches('input[name="purchaseType"]') ||
          e.target.matches('select[name="stayai_selling_plan"]')
        ) {
          setTimeout(pushPriceUpdate, 50);
        }
      });

      const subPriceEl = stayHost.querySelector('[data-stayai-subscription-price]');
      if (subPriceEl) {
        new MutationObserver(() => {
          // Guard: if current variant has no selling plans, Stay AI's DOM
          // mutation is stale from the previous variant — skip it
          if (isSubscriptionSelected()) {
            const vs = document.querySelector('product-variant-selector');
            if (vs) {
              const variant = vs.variants.find((v) => v.id === vs.selectedVariantId);
              if (variant && (!variant.selling_plan_allocations || variant.selling_plan_allocations.length === 0)) {
                return;
              }
            }
          }
          setTimeout(pushPriceUpdate, 50);
        }).observe(subPriceEl, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      setTimeout(pushPriceUpdate, 200);
    }
    // ── end Stay AI price sync ────────────────────────────────────────────────

    // Patch ProductVariantSelector — gallery scroll + PS rebind + Stay AI sync
    function patchVariantSelector(el) {
      if (!el || el._galleryPatched) return;
      el._galleryPatched = true;

      const original = el.selectVariant.bind(el);
      el.selectVariant = async function (variantId) {
        await original(variantId);
        const variant = this.variants.find(
          (v) => v.id === (typeof variantId === 'string' ? parseInt(variantId, 10) : variantId)
        );
        if (variant?.featured_media?.id) {
          slideToMediaId(variant.featured_media.id);
        }

        if (variant?.sku) {
          const psSku = document.querySelector('meta[name="ps-sku"]');
          if (psSku) psSku.setAttribute('content', variant.sku);
          if (window.PriceSpider) window.PriceSpider.rebind();
        }

        setTimeout(() => syncPriceFromStayAi(this), 300);
      };

      syncPriceFromStayAi(el);
    }

    document.querySelectorAll('product-variant-selector').forEach(patchVariantSelector);

    const observer = new MutationObserver(() => {
      document.querySelectorAll('product-variant-selector').forEach(patchVariantSelector);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  // ── end initGallery ──────────────────────────────────────────────────────────

  // ── Product info section tabs (no Swiper dependency) ──
  const SINGLE_OPEN = true;
  const sections = document.querySelectorAll(".product-info");

  const setOpenState = (section, open) => {
    const btn = section.querySelector(".product-info-button");
    const content = section.querySelector(".product-info-content");
    const plus = section.querySelector(".product-info-button .plus");
    const minus = section.querySelector(".product-info-button .minus");

    if (!btn || !content || !plus || !minus) return;

    if (open) {
      content.classList.remove("hidden");
      plus.classList.add("hidden");
      minus.classList.remove("hidden");
      btn.setAttribute("aria-expanded", "true");
    } else {
      content.classList.add("hidden");
      plus.classList.remove("hidden");
      minus.classList.add("hidden");
      btn.setAttribute("aria-expanded", "false");
    }
  };

  sections.forEach((section) => {
    const btn = section.querySelector(".product-info-button");
    if (!btn) return;

    setOpenState(section, false);
    btn.setAttribute("aria-controls", "");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("type", "button");

    btn.addEventListener("click", () => {
      const content = section.querySelector(".product-info-content");
      const isOpen = !content.classList.contains("hidden");
      if (SINGLE_OPEN && !isOpen) {
        sections.forEach((s) => s !== section && setOpenState(s, false));
      }
      setOpenState(section, !isOpen);
    });
  });

  // ── Product quantity inputs ──
  const productQtyInputs = document.querySelectorAll(".product-qty");
  productQtyInputs.forEach((input) => {
    const wrapper = input.closest("div");
    if (!wrapper) return;

    const minusBtn = wrapper.querySelector("button:first-of-type");
    const plusBtn = wrapper.querySelector("button:last-of-type");

    let value = parseInt(input.value, 10) || 1;

    const updateValue = (newVal) => {
      const maxValue = parseInt(input.dataset.max) || 9999;
      if (newVal < 1) newVal = 1;
      if (newVal > maxValue) newVal = maxValue;
      value = newVal;
      input.value = value;
    };

    minusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(value - 1);
    });

    plusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(value + 1);
    });
  });

  // ── Scroll to anchor after page settles ──
  const targetId = window.__scrollTarget;
  if (targetId) {
    let lastHeight = 0;
    let stableCount = 0;

    const interval = setInterval(() => {
      const currentHeight = document.body.scrollHeight;
      if (currentHeight === lastHeight) {
        stableCount++;
      } else {
        stableCount = 0;
        lastHeight = currentHeight;
      }

      if (stableCount >= 5) {
        clearInterval(interval);
        const el = document.getElementById(targetId);
        if (el) {
          const headerWrap = document.querySelector('.header-wrap');
          const navHeight = headerWrap ? headerWrap.offsetHeight + 40 : 120;
          const top = el.getBoundingClientRect().top + window.scrollY - navHeight - 16;
          window.scrollTo({ top, behavior: 'smooth' });
          history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${targetId}`);
        }
      }
    }, 200);

    setTimeout(() => clearInterval(interval), 15000);
  }

});


// ── GA4 Events Helper ──
(function () {
  let attempts = 0;

  function waitForGtag() {
    attempts++;
    if (typeof window.gtag === 'function') {
      setupTracking();
    } else if (attempts < 50) {
      setTimeout(waitForGtag, 100);
    }
  }

  function setupTracking() {
    const retailerMap = {
      'walmart': 'pdp_click_walmart',
      'amazon': 'pdp_click_amazon',
      'target': 'pdp_click_target',
      'chewy': 'pdp_click_chewy',
      'petsmart': 'pdp_click_petsmart',
      'tractorsupply': 'pdp_click_tractorsupply',
      'tractor supply': 'pdp_click_tractorsupply',
      'petco': 'pdp_click_petco',
    };

    function getEventNameFromText(text) {
      const lowerText = text.toLowerCase();
      for (const [key, value] of Object.entries(retailerMap)) {
        if (lowerText.includes(key)) return value;
      }
      return 'pdp_click_other_retailer';
    }

    function getEventNameFromUrl(url) {
      const lowerUrl = url.toLowerCase();
      for (const [key, value] of Object.entries(retailerMap)) {
        if (lowerUrl.includes(key)) return value;
      }
      return 'pdp_click_other_retailer';
    }

    function getDomain(url) {
      try {
        return new URL(url).hostname.replace(/^www\./, '').toLowerCase();
      } catch (e) {
        return '';
      }
    }

    document.addEventListener('click', function (e) {
      const psContainer = e.target.closest('.ps-wtb');
      if (!psContainer) return;

      const button = e.target.closest('button.ps-online-buy-button, button.ps-online-seller-button');
      if (button) {
        const ariaLabel = button.getAttribute('aria-label') || '';
        const buttonText = button.textContent || '';
        const combinedText = ariaLabel + ' ' + buttonText;
        const eventName = getEventNameFromText(combinedText);

        window.gtag('event', eventName, {
          button_text: buttonText.trim(),
          aria_label: ariaLabel,
          page_location: window.location.href,
          page_path: window.location.pathname,
          transport_type: 'beacon',
        });
        return;
      }

      const link = e.target.closest('a');
      if (link && link.href) {
        const url = link.href;
        const eventName = getEventNameFromUrl(url);

        window.gtag('event', eventName, {
          link_url: url,
          retailer_domain: getDomain(url),
          page_location: window.location.href,
          page_path: window.location.pathname,
          transport_type: 'beacon',
        });
      }
    }, true);
  }

  waitForGtag();
})();